module.exports = __webpack_public_path__ + "app/principal/user/principal-user-8BvtIGeA.html";